import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IMapKitState } from "../interfaces/mapkit";

export interface IGoogleMapsSlice {
    isLoaded: boolean; // has google maps been loaded?
}

const initState: IGoogleMapsSlice = {
    isLoaded: false
};

// This reducer simply stores whether the google maps has been loaded
// and initialized. When both happen then it's safe to use.
const googleMapsSlice = createSlice({
    name: 'googlemaps',
    initialState: initState,
    reducers: {
        setLoaded(state: IMapKitState, action: PayloadAction<boolean>) {
            state.isLoaded = action.payload;
            //console.log("Google maps ready");
        }
    }
});

export const {
    setLoaded
} = googleMapsSlice.actions;

export default googleMapsSlice.reducer;